import { getNameInitials } from './getNameInitials';
import { never } from './never';

export interface IPerson {
    nameFamily?: string | null;
    nameFamily2?: string | null;
    nameGiven?: string | null;
    nameInfix?: string | null;
    nameInfix2?: string | null;
    nameInitials?: string | null;
    nameUsual?: string | null;
}

export type GetDisplayNameFormat =
    | 'initialsFamilyName'
    | 'familyNameCommaInitials'
    | 'familyNameCommaFirstName'
    | 'nameGivenNameFamily'
    | 'familyName';

export function getDisplayName(
    person: IPerson,
    includeNameUsual = false,
    format: GetDisplayNameFormat = 'initialsFamilyName'
) {
    const familyName = displayFamilyName(person, includeNameUsual);
    const nameInitials = displayNameInitials(person);

    switch (format) {
        case 'initialsFamilyName':
            return `${nameInitials} ${familyName}`;
        case 'familyNameCommaInitials':
            return `${familyName}${nameInitials ? ', ' + nameInitials : ''}`;
        case 'familyNameCommaFirstName':
            return `${familyName}${person.nameGiven ? `, ${person.nameGiven}` : ''}`;
        case 'nameGivenNameFamily':
            return `${person.nameGiven ? `${person.nameGiven} ` : ''}${familyName}`;
        case 'familyName':
            return familyName;
        default:
            return never(format);
    }
}

export function displayFamilyName(person: IPerson, includeNameUsual?: boolean) {
    let nameDisplay = '';
    if (includeNameUsual && person.nameUsual) {
        nameDisplay += ' (' + person.nameUsual + ')';
    }

    if (person.nameInfix) {
        nameDisplay += ' ' + person.nameInfix;
    }

    if (person.nameFamily) {
        nameDisplay += ' ' + person.nameFamily;
    }

    if (person.nameInfix2 || person.nameFamily2) {
        nameDisplay += ' -';
        if (person.nameInfix2) {
            nameDisplay += ' ' + person.nameInfix2;
        }

        if (person.nameFamily2) {
            nameDisplay += ' ' + person.nameFamily2;
        }
    }

    return nameDisplay.trim();
}

export function displayNameInitials(person: IPerson) {
    if (person.nameGiven) {
        return getNameInitials(person.nameGiven) + '';
    } else if (person.nameInitials) {
        return person.nameInitials + '';
    }

    return '';
}
